import { useReduxState } from 'hooks';
import { CopyButton } from 'components/common';

const SiteSettingsThemesExport = ({ value }) => {
  const { messages } = useReduxState();

  return (
    <CopyButton
      aria-label={messages.commonExportData}
      icon="copy"
      text={messages.commonExportData}
      successText={messages.commonCopied}
      value={value}
    />
  );
};

export default SiteSettingsThemesExport;
